<div class="flex flex-wrap items-center gap-4 p-3" [formGroup]="filterForm()">
  @for (field of filterConfig(); track field) {
    @if (field.isPrimary) {
      <siat-input-field
        class="flex-auto min-w-64"
        [controlName]="field.controlName"
        [formGroup]="filterForm()"
        [label]="field.label | translate"
        [placeholder]="field.placeholder | translate"
        (keydown.enter)="applyFilters()"
      ></siat-input-field>
    }
  }
  @if (filterConfig()?.length > 1) {
    <button
      mat-icon-button
      (click)="panel.toggle()"
      [attr.aria-label]="
        panel.expanded
          ? ('GENERAL.hide_advanced_search' | translate)
          : ('GENERAL.show_advanced_search' | translate)
      "
      [matTooltip]="
        panel.expanded
          ? ('GENERAL.hide_advanced_search' | translate)
          : ('GENERAL.show_advanced_search' | translate)
      "
      type="button"
    >
      <mat-icon
        [matBadge]="activeFilterCount"
        matBadgeColor="warn"
        aria-hidden="false"
        [matBadgeHidden]="activeFilterCount === 0"
        >tune</mat-icon
      >
    </button>
  }
  <div class="grow flex justify-end gap-2">
    <button
      mat-raised-button
      (click)="resetFilters()"
      [attr.aria-label]="'GENERAL.reset_filter_tooltip' | translate"
      [matTooltip]="'GENERAL.reset_filter_tooltip' | translate"
      type="button"
      [disabled]="!filterForm().valid"
    >
      {{ 'GENERAL.reset' | translate }}
    </button>
    <button
      mat-raised-button
      (click)="applyFilters()"
      type="button"
      [disabled]="!filterForm().valid"
      [attr.aria-label]="'GENERAL.filter_tooltip' | translate"
      [matTooltip]="'GENERAL.filter_tooltip' | translate"
    >
      {{ 'GENERAL.search' | translate }}
    </button>
  </div>
</div>

@if (activeFilters.length > 0) {
  <div class="flex flex-wrap items-center gap-4 px-3">
    @for (filter of activeFilters; track filter.key) {
      <mat-chip-row class="bg-gray-100" (removed)="removeFilter(filter.key)">
        <strong>{{ filter.label | translate }}:</strong>&nbsp;{{ filter.value }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </div>
}

<mat-expansion-panel #panel style="box-shadow: none">
  <div
    class="flex flex-wrap gap-4 pt-4 px-3 bg-[#ededee]"
    [formGroup]="filterForm()"
  >
    @for (field of filterConfig(); track field.controlName) {
      @if (!field.isPrimary) {
        @if (field.type === 'text') {
          <siat-input-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            (keydown.enter)="applyFilters()"
            [label]="field.label | translate"
            [placeholder]="field.placeholder | translate"
          ></siat-input-field>
        }
        @if (field.type === 'select-tipologica') {
          <siat-select-tipologica-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            [label]="field.label | translate"
            (keydown.enter)="applyFilters()"
            [endpoint]="field.endpoint"
            [placeholder]="field.placeholder | translate"
          ></siat-select-tipologica-field>
        }
        @if (field.type === 'checkbox') {
          <siat-checkbox-field
            [formGroup]="filterForm()"
            [controlName]="field.controlName"
            (keydown.enter)="applyFilters()"
            [label]="field.label | translate"
          ></siat-checkbox-field>
        }
        @if (field.type === 'select') {
          <siat-select-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            (keydown.enter)="applyFilters()"
            [showLabel]="true"
            [label]="field.label | translate"
            [items]="field.options()"
            [placeholder]="field.placeholder | translate"
          ></siat-select-field>
        }
        @if (field.type === 'date') {
          <siat-datepicker-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            (keydown.enter)="applyFilters()"
            [label]="field.label | translate"
            [placeholder]="field.placeholder | translate"
          ></siat-datepicker-field>
        }
        @if (field.type === 'multi-select') {
          <siat-multiselect-field
            [controlName]="field.controlName"
            [label]="field.label | translate"
            (keydown.enter)="applyFilters()"
            [items]="field.options()"
            [formGroup]="filterForm()"
            [placeholder]="field.placeholder | translate"
          ></siat-multiselect-field>
        }
        @if (field.type === 'toggle') {
          <siat-switch-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            [label]="field.label | translate"
          ></siat-switch-field>
        }
        @if (field.type === 'radio-button') {
          <siat-radio-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            [label]="field.label | translate"
          ></siat-radio-field>
        }
        @if (field.type === 'textarea') {
          <siat-textarea-field
            [controlName]="field.controlName"
            [formGroup]="filterForm()"
            (keydown.enter)="applyFilters()"
            [label]="field.label | translate"
            [placeholder]="field.placeholder | translate"
          ></siat-textarea-field>
        }
      }
    }
  </div>
</mat-expansion-panel>
